// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iHis","label":"styles_label__2MKlu"};